import type { UserInfo } from "./authentication-service";

export class ExtendedUserInfo implements UserInfo {
    private _permissions: Set<string>;
    private _username: string;
    private _firstName: string | undefined;
    private _lastName: string | undefined;
    private _email: string | undefined;

    constructor(username: string, firstName: string | undefined, lastName: string | undefined, email: string | undefined, permissions: string[]) {
        this._permissions = new Set(permissions);
        this._username = username;
        this._firstName = firstName;
        this._lastName = lastName;
        this._email = email;
        this._permissions = new Set(permissions);
    }

    static toSerializable(instance: ExtendedUserInfo) {
        return {
            username: instance._username,
            firstName: instance._firstName,
            lastName: instance._lastName,
            email: instance._email,
            permissions: Array.from(instance._permissions)
        };
    }

    static fromSerializable(data: any) {
        if (data == null) {
            return null;
        }
        return new ExtendedUserInfo(data.username, data.firstName, data.lastName, data.email, data.permissions);
    }

    get username() {
        return this._username;
    }

    get email() {
        return this._email;
    }

    get firstName() {
        return this._firstName;
    }

    get lastName() {
        return this._lastName;
    }

    get permissions() {
        return this._permissions;
    }
}